import"./../jbTheme.css.ts.vanilla.css";import"./jbGlobalTheme.css.ts.vanilla.css";var s=function(){return null};export{s as default};
//# sourceMappingURL=JbGlobalTheme.js.map
